import { useMemo } from 'react';

import { useUserThreads } from './useUserThreads';

/**
 * Hook for managing threads list with real data from API
 * Provides the same interface as before but now uses real data
 * @returns {object} Hook state and methods
 */
export function useThreadsList() {
  const { threads: rawThreads, loading, error, refetch } = useUserThreads();

  // Transform and enhance threads with title fallback and other UI-specific logic
  const threads = useMemo(() => {
    const transformedThreads = rawThreads
      .map((thread) => ({
        ...thread,
        title: thread.title,
        // Keep dates as strings to match component PropTypes expectations
        createdAt: thread.createdAt,
        updatedAt: thread.updatedAt,
        lastMessageAt: thread.lastMessageAt
      }))
      .sort((a, b) => new Date(b.lastMessageAt) - new Date(a.lastMessageAt)); // Sort by last message date descending

    return transformedThreads;
  }, [rawThreads]);

  /**
   * Refetch threads list with cache-busting
   * @returns {Promise} Promise resolving when refetch completes
   */
  const refetchThreads = async () => {
    const result = await refetch();
    return result;
  };

  return {
    threads,
    loading,
    error,
    refetch: refetchThreads
  };
}
